import React from 'react';
import PropTypes from 'prop-types';

import { ChatItem } from 'react-chat-elements';

import routes from 'app/routes';

import { useNavigate } from 'react-router-dom';

export default function ListItem({ currentChat, setChat, chat }) {
  const navigate = useNavigate();

  return (
    <ChatItem
      className={currentChat && currentChat.id === chat.id ? 'rce-active' : ''}
      avatar={chat.links.coach_avatar}
      alt="avatar"
      title={chat.attributes.coach}
      subtitle={chat.attributes.last_message_body}
      unread={chat.attributes.unread}
      onClick={() => {
        setChat(chat);
        navigate(routes.members.chats.messages(chat.id));
      }}
    />
  );
}

ListItem.propTypes = {
  currentChat: PropTypes.object,
  setChat: PropTypes.func.isRequired,
  chat: PropTypes.object.isRequired,
};

ListItem.defaultProps = {
  currentChat: null,
};
